import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class GearManagementService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getGearAdvices() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + '/Component/Type/Advices?code=' + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBikeTypes() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(this.env.url + '/bike/Types?code=' + this.env.key, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getGearAdvice(ID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Component/Type/Advice/Portal?code=${this.env.key}&ID=${ID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postGearAdvice(Data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Component/Type/Advice?code=${this.env.key}`,
        Data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  removeGearAdvice(Data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
          `/Component/Type/Advice?code=${this.env.key}&ID=${Data.id}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getGearTypes(BikeTypeID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          '/v2/Components/Types?BikeTypeID=' +
          BikeTypeID +
          '&code=' +
          this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
